import React from 'react';
import CardsContent from "./resumed/cards-content.jsx";
import ActionsHistoryContent from "./resumed/actions-history-content.jsx";
import DispatchReasonContent from "./resumed/dispatch-reason-content.jsx";
import BosReasonContent from "./resumed/bos-reason-content.jsx";
import DetentionsReasonContent from "./resumed/detentions-reason-content.jsx";
import ApprehensionsTypeContent from "./resumed/apprehensions-type-content.jsx";


const ResumedContent = ({ data, boName, month, year, collapsed }) => {
    return (
        <>
            <div className="report-divisor mb-6">
                <span className="divisor-title">
                    AÇÕES <span className={'font-bold'}>{month.toUpperCase()} {year}</span>
                </span>
            </div>

            <CardsContent key={`cards-${collapsed}`} data={data} boName={boName}/>

            <ActionsHistoryContent key={`history-${collapsed}`} data={data} boName={boName} year={year}/>

            <DispatchReasonContent key={`dispatch-reason-${collapsed}`} data={data}/>

            <BosReasonContent key={`bos-reason-${collapsed}`} data={data} boName={boName}/>

            <DetentionsReasonContent key={`detentions-reason-${collapsed}`} data={data}/>

            <ApprehensionsTypeContent key={`apprehensions-type-${collapsed}`} data={data}/>
        </>
    );
};

export default ResumedContent;